import { render, staticRenderFns } from "./SavingsPage.vue?vue&type=template&id=286f7323&"
import script from "./SavingsPage.vue?vue&type=script&lang=js&"
export * from "./SavingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports